import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import $ from "jquery/dist/jquery.js";
import menuApi from "../api/menuApi";
import store from '../store/configureStore';
import { lang } from "../config/lang";
import { addNotification } from "../actions/notificationAction";
import LangMenu from "./LangMenu";
import HeaderSearchBox from './HeaderSearchBox';
import leadershipApi from '../api/leadershipApi';
import { withRouter } from 'react-router-dom';
/****************************************
    Top Header
    @author  IMH003
    @date    2019.5.24
    @version 0.1    
 ******************************************/
class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            search_key: '',
            activeBusiness: 999,
            language: '',
            arrNavItem: [],
            arrNewsArticles: [],
            showSearch: true,
        }

        this.onClickClose = this.onClickClose.bind(this);
        this.onSearchKeyChanged = this.onSearchKeyChanged.bind(this);

    }

    componentWillMount() {
    }

    componentDidMount() {
        window.menuShowCheck();
    }

    componentWillUnmount() {
    }

    componentWillReceiveProps(newProps) {
        const activeMenu = newProps.navBar.active_navItem;
        const new_lang = newProps.language.lang_key;
        const showSearch = newProps.topBanner.showSearch;
        const isHome = newProps.topBanner.isHome;
        const globalSearch = newProps.topBanner.globalSearch;

        if (this.state.arrNavItem.length > 0 && this.state.language === new_lang) {
            this.setState({
                ...this.state,
                activeBusiness: activeMenu,
                showSearch,
                isHome,
                globalSearch
            })
        } else {
            menuApi.getMenuList().then((json) => {
                if (json.status === 200 && json.data) {
                    this.setState({
                        ...this.state,
                        activeBusiness: activeMenu,
                        arrNavItem: json.data,
                        language: new_lang,
                        showSearch,
                        globalSearch,
                        isHome
                    })
                } else {
                    store.dispatch(addNotification(`${lang('server_err')}`, 'error'));
                }
            })
            leadershipApi.getAll().then((json) => {
                let dateArray = []
                if (json.status === 200 && json.data) {
                    json.data.length && json.data.map((one, key) => (
                        dateArray.push(one.date)
                    ))
                    this.setState({
                        ...this.state,
                        arrNewsArticles: json.data.arryNewArticle,
                        arrDate: dateArray,
                        showSearch,
                        globalSearch,
                        isHome
                    })
                    $('#footer').css("visibility", "visible");
                } else {
                    if (json.status === 620) {
                        store.dispatch(addNotification(`${lang('access_deny')}`, 'error'));
                    }
                }
            })
        }
    }

    onClickClose() {
        window.onClose();
    }
    onSearchKeyChanged(key) {
        if (this.state.search_key === key) {
            return;
        }
        this.setState({
            search_key: key
        });
    }

    render() {
        return (
            (this.props.history.location.pathname.split("/")[1] != "revolution" || (this.props.history.location.pathname.split("/")[2] === "" || this.props.history.location.pathname.split("/").length == 2)) &&
                <nav className="header-nav-height menu_header navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light breakpoint-off" id="ftco-navbar" style={this.state.isHome || this.state.globalSearch ? { height: '150px' } : { height: '130px' }}>
                    <div className="container" style={this.state.isHome || this.state.globalSearch ? { marginBottom: '50px' } : {}}>
                        <div>
                            <button className="navbar-toggler js-fh5co-nav-toggle fh5co-nav-toggle" type="button" data-toggle="collapse" data-target="#ftco-nav-top" aria-controls="ftco-nav-top" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="fa fa-bars"></span>
                            </button>
                            <Link className="navbar-brand" to="/home">
                                <img src="/assets/images/logo.png" alt="DPRK Tour" />
                            </Link>
                        </div>
                        <div className="menu">
                            <div className="menu_logo">
                                <Link className="navbar-brand" to="/home">
                                    <img src="/assets/images/logo.png" alt="DPRK Tour" />
                                </Link>
                                <div onClick={() => this.onClickClose()} className="pull-right menu_close_btn lang-menu-close">
                                    <span className="icon-close2 js-menu-toggle"></span>
                                </div>
                            </div>

                            <div className="menu_content">
                                <ul className="navbar-nav nav ml-auto">
                                    {
                                        this.state.arrNavItem.map((navItem, key) => (
                                            <li className="collapse_nav nav-item" key={key}>
                                                <Link
                                                    to={navItem.route}
                                                    className={`${navItem.business === this.state.activeBusiness ?
                                                        'nav-link active' : 'nav-link'}`}
                                                >
                                                    <span className='header-nav-character' style={{ fontSize: localStorage.getItem('language') === 'ru' ? '14px' : '20px' }} dangerouslySetInnerHTML={{ __html: navItem.title === undefined || navItem.title === null ? '' : navItem.title }} />
                                                </Link>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className="collapse navbar-collapse my-menu" id="ftco-nav-top_menu">

                            <ul className="navbar-nav nav ml-auto">
                                {
                                    this.state.arrNavItem.map((navItem, key) => (
                                        <li className="nav-item" key={key}>
                                            <Link
                                                to={navItem.route}
                                                className={`${navItem.business === this.state.activeBusiness ?
                                                    'nav-link active' : 'nav-link'}`}>
                                                <span className='header-nav-character' style={{ lineHeight: '1', margin: '0', fontSize: localStorage.getItem('language') === 'ru' ? '14px' : '20px' }} dangerouslySetInnerHTML={{ __html: navItem.title === undefined || navItem.title === null ? '' : navItem.title }}></span>
                                            </Link>
                                            {navItem.count && navItem.count.count != 0 ? <div className={"alarm"}>{navItem.count.count}</div> : ""}
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                        {this.state.isHome || this.state.globalSearch ? <HeaderSearchBox onSearch={(key) => this.onSearchKeyChanged(key)} /> : ''}
                        <div>
                            <ul className="langmenu ">
                                <LangMenu />
                            </ul>
                        </div>
                    </div>
                </nav>
        );
    }
}

function mapStateToProps(state) {
    return {
        navBar: state.navBar,
        language: state.language,
        topBanner: state.topBanner
    };
}

export default withRouter(connect(mapStateToProps)(Header));